import { call, put, takeLatest } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

const endpoint = `${config.credentials.url}/agency-incentive`;

function* getAgencyIncentiveList(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const query = actions.query ? actions.query : "";
        const url = `${endpoint}/${query}`;

        const response = yield call(
            apiCall,
            "GET",
            url,
            { headers }
        );

        yield put({
            type: "AGENCY_INCENTIVE_LIST_RESPONSE",
            value: response,
        });

    } catch (error) {
        yield put({
            type: "AGENCY_INCENTIVE_ERROR",
            error,
        });
    }
}

function* getAgencyIncentiveDetail(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const url = `${endpoint}/${actions.id}/`;

        const response = yield call(
            apiCall,
            "GET",
            url,
            { headers }
        );

        yield put({
            type: "AGENCY_INCENTIVE_DETAIL_RESPONSE",
            value: response,
        });

    } catch (error) {
        yield put({
            type: "AGENCY_INCENTIVE_ERROR",
            error,
        });
    }
}

function* createAgencyIncentive(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers,
            body: JSON.stringify(actions.payload),
        };

        const response = yield call(
            apiCall,
            "POST",
            `${endpoint}/`,
            requestOptions
        );

        yield put({
            type: "AGENCY_INCENTIVE_CREATE_RESPONSE",
            value: response,
        });
    } catch (error) {
        yield put({
            type: "AGENCY_INCENTIVE_CREATE_ERROR",
            error,
        });
    }
}

function* updateAgencyIncentive(actions) {
    try {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${actions.access}`,
        };

        const requestOptions = {
            headers,
            body: JSON.stringify(actions.payload),
        };

        const response = yield call(
            apiCall,
            "PATCH",
            `${endpoint}/${actions.id}/`,
            requestOptions
        );

        yield put({
            type: "AGENCY_INCENTIVE_UPDATE_RESPONSE",
            value: response,
        });
    } catch (error) {
        yield put({
            type: "AGENCY_INCENTIVE_UPDATE_ERROR",
            error,
        });
    }
}

export default function* sagaAgencyIncentive() {
    yield takeLatest("AGENCY_INCENTIVE_LIST_REQUEST", getAgencyIncentiveList);
    yield takeLatest("AGENCY_INCENTIVE_DETAIL_REQUEST", getAgencyIncentiveDetail);
    yield takeLatest("AGENCY_INCENTIVE_CREATE_REQUEST", createAgencyIncentive);
    yield takeLatest("AGENCY_INCENTIVE_UPDATE_REQUEST", updateAgencyIncentive);
}
